import { useNavigate } from "react-router-dom";

import { Button, Span } from "@icg360/design-system";

import styles from "components/notifications/notifications-drawer/notification-item.module.scss";
import { trackEvent } from "utils";

import { useNotifications } from "../context";

export const NotificationItem = () => {
  const navigate = useNavigate();
  const { notifications, dismiss, closeDrawer } = useNotifications();

  return (
    <div className={styles.notificationsGroup}>
      {notifications.map((notification) => {
        const notificationTitle = notification.offerTitle ?? "";
        const notificationButtonText =
          notification.buttonText != undefined
            ? `Learn more about ${notification.buttonText}`
            : `Get started`;
        const isUnread = !notification.read;
        return (
          <div
            key={notification.offerInternalName}
            className={
              isUnread
                ? styles.unreadNotificationHolder
                : styles.notificationHolder
            }
          >
            <div className={styles.notificationContent}>
              <Span size="md" className={styles.notificationTitle}>
                {notificationTitle}
              </Span>
              <Span size="sm" className={styles.notificationDescription}>
                {notification.offerDescription}
              </Span>
            </div>
            <div className={styles.notificationActions}>
              <Button
                appearance="secondary"
                size="md"
                aria-label={`Dismiss ${notificationTitle}`}
                data-testid="notification-dismiss-button"
                onPress={() => {
                  trackEvent("Notification dismissed", {
                    offerInternalName: notification.offerInternalName,
                  });
                  dismiss([notification]);
                }}
              >
                Dismiss
              </Button>
              <Button
                className={styles.learnMoreButton}
                appearance="primary"
                size="md"
                aria-label={`Click to learn more about ${notificationTitle}`}
                data-testid="notification-cta-button"
                onPress={() => {
                  trackEvent("Notification CTA clicked", {
                    offerInternalName: notification.offerInternalName,
                    path: notification.path,
                  });
                  closeDrawer();
                  if (notification.path) {
                    navigate(notification.path);
                  }
                }}
              >
                {notificationButtonText}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
